import { define } from 'wicked-elements'

define('[data-component~="navigation-mobile"]', {
  init() {
    this.handleClick = this.handleClick.bind(this)
  },
  connected() {
    this.element.addEventListener('click', this.handleClick)
  },
  disconnected() {
    this.element.removeEventListener('click', this.handleClick)
  },
  handleClick(e) {
    /* Close any open details elements that this click is outside of */
    var target = e.target
    var detailsClickedWithin = null
    while (target && target.tagName != 'DETAILS') {
      target = target.parentNode
    }
    if (target && target.tagName == 'DETAILS') {
      detailsClickedWithin = target
    }
    Array.from(this.element.querySelectorAll('details'))
      .filter((details) => details.open && details != detailsClickedWithin)
      .forEach((details) => (details.open = false))
  },
})
